<div class="rp-dialog">
  <div class="rp-header">
    <div class="rp-header-main">
      <mat-icon class="rp-header-icon">person_search</mat-icon>
      <h2 class="rp-title">Verfügbarkeit finden</h2>
    </div>
    <button mat-icon-button class="rp-close" (click)="close()" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="avail-content">
    <div class="criteria">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Datum</mat-label>
        <input matInput type="date" [(ngModel)]="dateStr" (ngModelChange)="search()" />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="time">
        <mat-label>Von</mat-label>
        <input matInput type="time" [(ngModel)]="fromTime" (ngModelChange)="search()" />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="time">
        <mat-label>Bis</mat-label>
        <input matInput type="time" [(ngModel)]="toTime" (ngModelChange)="search()" />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="skills">
        <mat-label>Benötigte Skills</mat-label>
        <mat-select multiple [(ngModel)]="requiredSkillIds" (ngModelChange)="search()">
          <mat-option *ngFor="let s of data.skills" [value]="s.id">
            <span class="cat-dot" [style.background]="s.color"></span>{{ s.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <h3 class="free-h"><mat-icon>check_circle</mat-icon> Frei &amp; qualifiziert ({{ freeRows.length }})</h3>
    <div class="row-list">
      <div class="avail-row free" *ngFor="let r of freeRows">
        <div class="who">
          <span class="name">{{ r.user.name }}</span>
          <span class="chips">
            <span class="chip" *ngFor="let s of r.user.skills" [style.background]="s.color">{{ s.name }}</span>
          </span>
        </div>
        <button mat-flat-button color="primary" (click)="plan(r)">
          <mat-icon>add</mat-icon> Einplanen
        </button>
      </div>
      <p *ngIf="!loading && freeRows.length === 0" class="empty">Niemand frei in diesem Zeitfenster.</p>
    </div>

    <h3 class="busy-h"><mat-icon>block</mat-icon> Belegt ({{ busyRows.length }})</h3>
    <div class="row-list">
      <div class="avail-row busy" *ngFor="let r of busyRows">
        <div class="who">
          <span class="name">{{ r.user.name }}</span>
          <span class="reason">{{ r.reason }}</span>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="rp-actions">
    <span class="rp-spacer"></span>
    <button mat-stroked-button (click)="close()">Schließen</button>
  </mat-dialog-actions>
</div>
